import { createContext, useContext, type ReactNode } from "react";
import type { UseTourReturn } from "./use-tour";

const TourContext = createContext<UseTourReturn | null>(null);

export function TourContextProvider({
  value,
  children,
}: {
  value: UseTourReturn;
  children: ReactNode;
}) {
  return <TourContext.Provider value={value}>{children}</TourContext.Provider>;
}

export function useTourContext(): UseTourReturn {
  const ctx = useContext(TourContext);
  if (!ctx) {
    throw new Error("useTourContext must be used within TourContextProvider");
  }
  return ctx;
}
